import ServiceRequestsTemplate from 'text!../views/service-requests.html';
import ServiceRequestMessagesTemplate from 'text!../views/service-request-messages.html';
import ServiceRequestDetailsTemplate from 'text!../views/service-request-details.html';
import CreateMessageTemplate from 'text!../views/create-message.html';
import ViewReplyMessageTemplate from 'text!../views/view-reply-message.html';
import AddQuoteTemplate from 'text!../views/add-revise-quote.html';
import QuoteDetailsTemplate from 'text!../views/quote-details.html';
import AddInvoiceTemplate from 'text!../views/add-invoice.html';
import InvoiceDetailsTemplate from 'text!../views/invoice-details.html';
import WithdrawInvoiceTemplate from 'text!../views/withdraw-invoice.html';
import AcceptWorkTemplate from 'text!../views/accept-work.html';
import ReportDelayTemplate from 'text!../views/report-delay.html';
import DeclineWorkTemplate from 'text!../views/decline-work.html';
import CancelWorkTemplate from 'text!../views/cancel-work.html';
import CompleteWorkTemplate from 'text!../views/complete-work.html';
import ResumeWorkTemplate from 'text!../views/resume-work.html';
import ReportBlockedTemplate from 'text!../views/report-blocked.html';
import UpdateReferenceTemplate from 'text!../views/update-reference.html';
import ServiceRequestFlowCtrl from '../controllers/ServiceRequestFlowCtrl';
import ServiceRequestsCtrl from '../controllers/ServiceRequestsCtrl';
import ServiceRequestMessagesCtrl from '../controllers/ServiceRequestMessagesCtrl';
import ServiceRequestDetailsCtrl from '../controllers/ServiceRequestDetailsCtrl';
import CreateMessageCtrl from '../controllers/CreateMessageCtrl';
import ViewReplyMessageCtrl from '../controllers/ViewReplyMessageCtrl';
import QuoteDetailsCtrl from '../controllers/QuoteDetailsCtrl';
import InvoiceDetailsCtrl from '../controllers/InvoiceDetailsCtrl';
import WithdrawInvoiceCtrl from '../controllers/WithdrawInvoiceCtrl';
import WorkOperationsCtrl from '../controllers/ServiceRequestWorkOperationCtrl';
import UpdateReferenceCtrl from '../controllers/UpdateReferenceCtrl';
import ServiceRequestInvoiesTemplate from 'text!../views/service-request-invoices.html';
import ServiceRequestInvoicesCtrl from '../controllers/ServiceRequestInvoicesCtrl';
import CloseServiceTemplate from 'text!../views/close-service.html';

export default (RootStates) => {
    const parentState = RootStates.serviceRequests;

    return {
        serviceRequest: {
            name: 'serviceRequest',
            parent: parentState,
            controller: ServiceRequestFlowCtrl,
            abstract: true,
            url: '/service-requests',
            template: '<div ui-view></div>'
        },
        serviceRequestsList: {
            name: 'serviceRequestsList',
            parent: 'serviceRequest',
            controller: ServiceRequestsCtrl,
            abstract: false,
            url: '/list',
            template: ServiceRequestsTemplate,
            data: {
                label: 'Service Requests'
            }
        },
        serviceRequestMessages: {
            name: 'serviceRequestMessages',
            parent: 'serviceRequest',
            controller: ServiceRequestMessagesCtrl,
            abstract: false,
            url: '/messages',
            template: ServiceRequestMessagesTemplate,
            data: {
                label: 'Messages'
            }
        },
        serviceRequestDetails: {
            name: 'serviceRequestDetails',
            parent: 'serviceRequest',
            controller: ServiceRequestDetailsCtrl,
            abstract: false,
            url: '/?serviceRequestNumber&tab',
            template: ServiceRequestDetailsTemplate,
            data: {
                label: 'Service Request Details'
            }
        },
        createMessage: {
            name: 'createMessage',
            parent: 'serviceRequest',
            url: '/create-message/?serviceRequestNumber',
            template: CreateMessageTemplate,
            controller: CreateMessageCtrl,
            data: {
                actions: {
                    homepage: 'serviceRequestsList',
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        viewReplyMessage: {
            name: 'viewReplyMessage',
            parent: 'serviceRequest',
            url: '/view-message/?serviceRequestNumber&reply&previousState',
            template: ViewReplyMessageTemplate,
            controller: ViewReplyMessageCtrl,
            data: {
                actions: {
                    homepage: 'serviceRequestsList',
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        updateReference: {
            name: 'updateReference',
            parent: 'serviceRequest',
            url: '/update-reference/{serviceRequestNumber}',
            template: UpdateReferenceTemplate,
            controller: UpdateReferenceCtrl,
            data: {
                actions: {
                    homepage: 'serviceRequests',
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        addOrReviseQuote: {
            name: 'addOrReviseQuote',
            parent: 'serviceRequest',
            url: '/add-revise-quote/',
            template: AddQuoteTemplate,
            controller: QuoteDetailsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        quoteDetails: {
            name: 'quoteDetails',
            parent: 'serviceRequest',
            url: '/quote-details/',
            template: QuoteDetailsTemplate,
            controller: QuoteDetailsCtrl,
            data: {}
        },
        addInvoice: {
            name: 'addInvoice',
            parent: 'serviceRequest',
            url: '/add-invoice/',
            template: AddInvoiceTemplate,
            controller: InvoiceDetailsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        invoiceDetails: {
            name: 'invoiceDetails',
            parent: 'serviceRequest',
            url: '/invoice-details/',
            template: InvoiceDetailsTemplate,
            controller: InvoiceDetailsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails',
                    invoices: 'invoices'
                }
            }
        },
        withdrawInvoice: {
            name: 'withdrawInvoice',
            parent: 'serviceRequest',
            url: '/withdraw-invoice/',
            template: WithdrawInvoiceTemplate,
            controller: WithdrawInvoiceCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        acceptWork: {
            name: 'acceptWork',
            parent: 'serviceRequest',
            url: '/accept-work/',
            template: AcceptWorkTemplate,
            controller: WorkOperationsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        reportDelay: {
            name: 'reportDelay',
            parent: 'serviceRequest',
            url: '/report-delay/',
            template: ReportDelayTemplate,
            controller: WorkOperationsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        declineWork: {
            name: 'declineWork',
            parent: 'serviceRequest',
            url: '/decline-work/',
            template: DeclineWorkTemplate,
            controller: WorkOperationsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        cancelWork: {
            name: 'cancelWork',
            parent: 'serviceRequest',
            url: '/cancel-work/',
            template: CancelWorkTemplate,
            controller: WorkOperationsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        completeWork: {
            name: 'completeWork',
            parent: 'serviceRequest',
            url: '/complete-work/',
            template: CompleteWorkTemplate,
            controller: WorkOperationsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        resumeWork: {
            name: 'resumeWork',
            parent: 'serviceRequest',
            url: '/resume-work/',
            template: ResumeWorkTemplate,
            controller: WorkOperationsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        reportBlocked: {
            name: 'reportBlocked',
            parent: 'serviceRequest',
            url: '/report-blocked/',
            template: ReportBlockedTemplate,
            controller: WorkOperationsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
        invoices: {
            name: 'invoices',
            parent: 'serviceRequest',
            controller: ServiceRequestInvoicesCtrl,
            url: '/invoices',
            template: ServiceRequestInvoiesTemplate
        },
        closeService: {
            name: 'closeService',
            parent: 'serviceRequest',
            url: '/close-service/',
            template: CloseServiceTemplate,
            controller: WorkOperationsCtrl,
            data: {
                actions: {
                    serviceRequestDetails: 'serviceRequestDetails'
                }
            }
        },
    };
};
